var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _rect, _path11, _g3, _path12, _path13, _path14, _g4, _g5, _path15, _ellipse, _ellipse2, _rect2, _g6, _g7, _g8, _ellipse3, _path16, _g9, _rect3, _rect4, _g10, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGethelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 50,
    viewBox: "0 0 99 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 0C34.2386 0 32 2.23858 32 5V14C32 16.7161 34.1657 18.9264 36.8645 18.9982L34.9999 22.1774L41.38 19H94C96.7614 19 99 16.7614 99 14V5C99 2.23858 96.7614 0 94 0H37Z",
    fill: "#7F75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3171 5.732H51.4111V6.392H49.3171V5.732ZM49.3831 8H48.6031V3.8H51.6691V4.454H49.3831V8ZM52.2928 8V4.796H53.0068V5.678L52.9228 5.42C53.0188 5.204 53.1688 5.04 53.3728 4.928C53.5808 4.816 53.8388 4.76 54.1468 4.76V5.474C54.1148 5.466 54.0848 5.462 54.0568 5.462C54.0288 5.458 54.0008 5.456 53.9728 5.456C53.6888 5.456 53.4628 5.54 53.2948 5.708C53.1268 5.872 53.0428 6.118 53.0428 6.446V8H52.2928ZM56.2597 8.042C55.9037 8.042 55.5917 7.972 55.3237 7.832C55.0597 7.688 54.8537 7.492 54.7057 7.244C54.5617 6.996 54.4897 6.714 54.4897 6.398C54.4897 6.078 54.5597 5.796 54.6997 5.552C54.8437 5.304 55.0397 5.11 55.2877 4.97C55.5397 4.83 55.8257 4.76 56.1457 4.76C56.4577 4.76 56.7357 4.828 56.9797 4.964C57.2237 5.1 57.4157 5.292 57.5557 5.54C57.6957 5.788 57.7657 6.08 57.7657 6.416C57.7657 6.448 57.7637 6.484 57.7597 6.524C57.7597 6.564 57.7577 6.602 57.7537 6.638H55.0837V6.14H57.3577L57.0637 6.296C57.0677 6.112 57.0297 5.95 56.9497 5.81C56.8697 5.67 56.7597 5.56 56.6197 5.48C56.4837 5.4 56.3257 5.36 56.1457 5.36C55.9617 5.36 55.7997 5.4 55.6597 5.48C55.5237 5.56 55.4157 5.672 55.3357 5.816C55.2597 5.956 55.2217 6.122 55.2217 6.314V6.434C55.2217 6.626 55.2657 6.796 55.3537 6.944C55.4417 7.092 55.5657 7.206 55.7257 7.286C55.8857 7.366 56.0697 7.406 56.2777 7.406C56.4577 7.406 56.6197 7.378 56.7637 7.322C56.9077 7.266 57.0357 7.178 57.1477 7.058L57.5497 7.52C57.4057 7.688 57.2237 7.818 57.0037 7.91C56.7877 7.998 56.5397 8.042 56.2597 8.042ZM59.9921 8.042C59.6361 8.042 59.3241 7.972 59.0561 7.832C58.7921 7.688 58.5861 7.492 58.4381 7.244C58.2941 6.996 58.2221 6.714 58.2221 6.398C58.2221 6.078 58.2921 5.796 58.4321 5.552C58.5761 5.304 58.7721 5.11 59.0201 4.97C59.2721 4.83 59.5581 4.76 59.8781 4.76C60.1901 4.76 60.4681 4.828 60.7121 4.964C60.9561 5.1 61.1481 5.292 61.2881 5.54C61.4281 5.788 61.4981 6.08 61.4981 6.416C61.4981 6.448 61.4961 6.484 61.4921 6.524C61.4921 6.564 61.4901 6.602 61.4861 6.638H58.8161V6.14H61.0901L60.7961 6.296C60.8001 6.112 60.7621 5.95 60.6821 5.81C60.6021 5.67 60.4921 5.56 60.3521 5.48C60.2161 5.4 60.0581 5.36 59.8781 5.36C59.6941 5.36 59.5321 5.4 59.3921 5.48C59.2561 5.56 59.1481 5.672 59.0681 5.816C58.9921 5.956 58.9541 6.122 58.9541 6.314V6.434C58.9541 6.626 58.9981 6.796 59.0861 6.944C59.1741 7.092 59.2981 7.206 59.4581 7.286C59.6181 7.366 59.8021 7.406 60.0101 7.406C60.1901 7.406 60.3521 7.378 60.4961 7.322C60.6401 7.266 60.7681 7.178 60.8801 7.058L61.2821 7.52C61.1381 7.688 60.9561 7.818 60.7361 7.91C60.5201 7.998 60.2721 8.042 59.9921 8.042ZM64.8668 8.042C64.5988 8.042 64.3408 8.008 64.0928 7.94C63.8488 7.868 63.6548 7.782 63.5108 7.682L63.7988 7.112C63.9428 7.204 64.1148 7.28 64.3148 7.34C64.5148 7.4 64.7148 7.43 64.9148 7.43C65.1508 7.43 65.3208 7.398 65.4248 7.334C65.5328 7.27 65.5868 7.184 65.5868 7.076C65.5868 6.988 65.5508 6.922 65.4788 6.878C65.4068 6.83 65.3128 6.794 65.1968 6.77C65.0808 6.746 64.9508 6.724 64.8068 6.704C64.6668 6.684 64.5248 6.658 64.3808 6.626C64.2408 6.59 64.1128 6.54 63.9968 6.476C63.8808 6.408 63.7868 6.318 63.7148 6.206C63.6428 6.094 63.6068 5.946 63.6068 5.762C63.6068 5.558 63.6648 5.382 63.7808 5.234C63.8968 5.082 64.0588 4.966 64.2668 4.886C64.4788 4.802 64.7288 4.76 65.0168 4.76C65.2328 4.76 65.4508 4.784 65.6708 4.832C65.8908 4.88 66.0728 4.948 66.2168 5.036L65.9288 5.606C65.7768 5.514 65.6228 5.452 65.4668 5.42C65.3148 5.384 65.1628 5.366 65.0108 5.366C64.7828 5.366 64.6128 5.4 64.5008 5.468C64.3928 5.536 64.3388 5.622 64.3388 5.726C64.3388 5.822 64.3748 5.894 64.4468 5.942C64.5188 5.99 64.6128 6.028 64.7288 6.056C64.8448 6.084 64.9728 6.108 65.1128 6.128C65.2568 6.144 65.3988 6.17 65.5388 6.206C65.6788 6.242 65.8068 6.292 65.9228 6.356C66.0428 6.416 66.1388 6.502 66.2108 6.614C66.2828 6.726 66.3188 6.872 66.3188 7.052C66.3188 7.252 66.2588 7.426 66.1388 7.574C66.0228 7.722 65.8568 7.838 65.6408 7.922C65.4248 8.002 65.1668 8.042 64.8668 8.042ZM68.4707 8.042C68.1147 8.042 67.8027 7.972 67.5347 7.832C67.2707 7.688 67.0647 7.492 66.9167 7.244C66.7727 6.996 66.7007 6.714 66.7007 6.398C66.7007 6.078 66.7707 5.796 66.9107 5.552C67.0547 5.304 67.2507 5.11 67.4987 4.97C67.7507 4.83 68.0367 4.76 68.3567 4.76C68.6687 4.76 68.9467 4.828 69.1907 4.964C69.4347 5.1 69.6267 5.292 69.7667 5.54C69.9067 5.788 69.9767 6.08 69.9767 6.416C69.9767 6.448 69.9747 6.484 69.9707 6.524C69.9707 6.564 69.9687 6.602 69.9647 6.638H67.2947V6.14H69.5687L69.2747 6.296C69.2787 6.112 69.2407 5.95 69.1607 5.81C69.0807 5.67 68.9707 5.56 68.8307 5.48C68.6947 5.4 68.5367 5.36 68.3567 5.36C68.1727 5.36 68.0107 5.4 67.8707 5.48C67.7347 5.56 67.6267 5.672 67.5467 5.816C67.4707 5.956 67.4327 6.122 67.4327 6.314V6.434C67.4327 6.626 67.4767 6.796 67.5647 6.944C67.6527 7.092 67.7767 7.206 67.9367 7.286C68.0967 7.366 68.2807 7.406 68.4887 7.406C68.6687 7.406 68.8307 7.378 68.9747 7.322C69.1187 7.266 69.2467 7.178 69.3587 7.058L69.7607 7.52C69.6167 7.688 69.4347 7.818 69.2147 7.91C68.9987 7.998 68.7507 8.042 68.4707 8.042ZM70.1712 8L71.5812 6.164L71.5692 6.566L70.2252 4.796H71.0592L72.0012 6.056H71.6832L72.6312 4.796H73.4412L72.0852 6.566L72.0912 6.164L73.4952 8H72.6492L71.6592 6.662L71.9712 6.704L70.9992 8H70.1712ZM75.346 8.042C75.074 8.042 74.834 7.992 74.626 7.892C74.418 7.788 74.256 7.632 74.14 7.424C74.024 7.212 73.966 6.946 73.966 6.626V4.796H74.716V6.524C74.716 6.812 74.78 7.028 74.908 7.172C75.04 7.312 75.226 7.382 75.466 7.382C75.642 7.382 75.794 7.346 75.922 7.274C76.054 7.202 76.156 7.094 76.228 6.95C76.304 6.806 76.342 6.628 76.342 6.416V4.796H77.092V8H76.378V7.136L76.504 7.4C76.396 7.608 76.238 7.768 76.03 7.88C75.822 7.988 75.594 8.042 75.346 8.042ZM80.048 8V7.352L80.006 7.214V6.08C80.006 5.86 79.94 5.69 79.808 5.57C79.676 5.446 79.476 5.384 79.208 5.384C79.028 5.384 78.85 5.412 78.674 5.468C78.502 5.524 78.356 5.602 78.236 5.702L77.942 5.156C78.114 5.024 78.318 4.926 78.554 4.862C78.794 4.794 79.042 4.76 79.298 4.76C79.762 4.76 80.12 4.872 80.372 5.096C80.628 5.316 80.756 5.658 80.756 6.122V8H80.048ZM79.04 8.042C78.8 8.042 78.59 8.002 78.41 7.922C78.23 7.838 78.09 7.724 77.99 7.58C77.894 7.432 77.846 7.266 77.846 7.082C77.846 6.902 77.888 6.74 77.972 6.596C78.06 6.452 78.202 6.338 78.398 6.254C78.594 6.17 78.854 6.128 79.178 6.128H80.108V6.626H79.232C78.976 6.626 78.804 6.668 78.716 6.752C78.628 6.832 78.584 6.932 78.584 7.052C78.584 7.188 78.638 7.296 78.746 7.376C78.854 7.456 79.004 7.496 79.196 7.496C79.38 7.496 79.544 7.454 79.688 7.37C79.836 7.286 79.942 7.162 80.006 6.998L80.132 7.448C80.06 7.636 79.93 7.782 79.742 7.886C79.558 7.99 79.324 8.042 79.04 8.042ZM81.7186 8V3.548H82.4686V8H81.7186ZM47.3461 11.76C47.6021 11.76 47.8301 11.81 48.0301 11.91C48.2341 12.01 48.3941 12.164 48.5101 12.372C48.6261 12.576 48.6841 12.84 48.6841 13.164V15H47.9341V13.26C47.9341 12.976 47.8661 12.764 47.7301 12.624C47.5981 12.484 47.4121 12.414 47.1721 12.414C46.9961 12.414 46.8401 12.45 46.7041 12.522C46.5681 12.594 46.4621 12.702 46.3861 12.846C46.3141 12.986 46.2781 13.164 46.2781 13.38V15H45.5281V10.548H46.2781V12.66L46.1161 12.396C46.2281 12.192 46.3901 12.036 46.6021 11.928C46.8181 11.816 47.0661 11.76 47.3461 11.76ZM51.1474 15.042C50.7914 15.042 50.4794 14.972 50.2114 14.832C49.9474 14.688 49.7414 14.492 49.5934 14.244C49.4494 13.996 49.3774 13.714 49.3774 13.398C49.3774 13.078 49.4474 12.796 49.5874 12.552C49.7314 12.304 49.9274 12.11 50.1754 11.97C50.4274 11.83 50.7134 11.76 51.0334 11.76C51.3454 11.76 51.6234 11.828 51.8674 11.964C52.1114 12.1 52.3034 12.292 52.4434 12.54C52.5834 12.788 52.6534 13.08 52.6534 13.416C52.6534 13.448 52.6514 13.484 52.6474 13.524C52.6474 13.564 52.6454 13.602 52.6414 13.638H49.9714V13.14H52.2454L51.9514 13.296C51.9554 13.112 51.9174 12.95 51.8374 12.81C51.7574 12.67 51.6474 12.56 51.5074 12.48C51.3714 12.4 51.2134 12.36 51.0334 12.36C50.8494 12.36 50.6874 12.4 50.5474 12.48C50.4114 12.56 50.3034 12.672 50.2234 12.816C50.1474 12.956 50.1094 13.122 50.1094 13.314V13.434C50.1094 13.626 50.1534 13.796 50.2414 13.944C50.3294 14.092 50.4534 14.206 50.6134 14.286C50.7734 14.366 50.9574 14.406 51.1654 14.406C51.3454 14.406 51.5074 14.378 51.6514 14.322C51.7954 14.266 51.9234 14.178 52.0354 14.058L52.4374 14.52C52.2934 14.688 52.1114 14.818 51.8914 14.91C51.6754 14.998 51.4274 15.042 51.1474 15.042ZM55.2599 15V14.352L55.2179 14.214V13.08C55.2179 12.86 55.1519 12.69 55.0199 12.57C54.8879 12.446 54.6879 12.384 54.4199 12.384C54.2399 12.384 54.0619 12.412 53.8859 12.468C53.7139 12.524 53.5679 12.602 53.4479 12.702L53.1539 12.156C53.3259 12.024 53.5299 11.926 53.7659 11.862C54.0059 11.794 54.2539 11.76 54.5099 11.76C54.9739 11.76 55.3319 11.872 55.5839 12.096C55.8399 12.316 55.9679 12.658 55.9679 13.122V15H55.2599ZM54.2519 15.042C54.0119 15.042 53.8019 15.002 53.6219 14.922C53.4419 14.838 53.3019 14.724 53.2019 14.58C53.1059 14.432 53.0579 14.266 53.0579 14.082C53.0579 13.902 53.0999 13.74 53.1839 13.596C53.2719 13.452 53.4139 13.338 53.6099 13.254C53.8059 13.17 54.0659 13.128 54.3899 13.128H55.3199V13.626H54.4439C54.1879 13.626 54.0159 13.668 53.9279 13.752C53.8399 13.832 53.7959 13.932 53.7959 14.052C53.7959 14.188 53.8499 14.296 53.9579 14.376C54.0659 14.456 54.2159 14.496 54.4079 14.496C54.5919 14.496 54.7559 14.454 54.8999 14.37C55.0479 14.286 55.1539 14.162 55.2179 13.998L55.3439 14.448C55.2719 14.636 55.1419 14.782 54.9539 14.886C54.7699 14.99 54.5359 15.042 54.2519 15.042ZM56.9305 15V10.548H57.6805V15H56.9305ZM60.0291 15.042C59.6771 15.042 59.4051 14.952 59.2131 14.772C59.0211 14.588 58.9251 14.318 58.9251 13.962V11.088H59.6751V13.944C59.6751 14.096 59.7131 14.214 59.7891 14.298C59.8691 14.382 59.9791 14.424 60.1191 14.424C60.2871 14.424 60.4271 14.38 60.5391 14.292L60.7491 14.826C60.6611 14.898 60.5531 14.952 60.4251 14.988C60.2971 15.024 60.1651 15.042 60.0291 15.042ZM58.3971 12.42V11.82H60.5331V12.42H58.3971ZM63.184 11.76C63.44 11.76 63.668 11.81 63.868 11.91C64.072 12.01 64.232 12.164 64.348 12.372C64.464 12.576 64.522 12.84 64.522 13.164V15H63.772V13.26C63.772 12.976 63.704 12.764 63.568 12.624C63.436 12.484 63.25 12.414 63.01 12.414C62.834 12.414 62.678 12.45 62.542 12.522C62.406 12.594 62.3 12.702 62.224 12.846C62.152 12.986 62.116 13.164 62.116 13.38V15H61.366V10.548H62.116V12.66L61.954 12.396C62.066 12.192 62.228 12.036 62.44 11.928C62.656 11.816 62.904 11.76 63.184 11.76ZM67.1316 15V11.796H67.8456V12.678L67.7616 12.42C67.8576 12.204 68.0076 12.04 68.2116 11.928C68.4196 11.816 68.6776 11.76 68.9856 11.76V12.474C68.9536 12.466 68.9236 12.462 68.8956 12.462C68.8676 12.458 68.8396 12.456 68.8116 12.456C68.5276 12.456 68.3016 12.54 68.1336 12.708C67.9656 12.872 67.8816 13.118 67.8816 13.446V15H67.1316ZM71.0986 15.042C70.7426 15.042 70.4306 14.972 70.1626 14.832C69.8986 14.688 69.6926 14.492 69.5446 14.244C69.4006 13.996 69.3286 13.714 69.3286 13.398C69.3286 13.078 69.3986 12.796 69.5386 12.552C69.6826 12.304 69.8786 12.11 70.1266 11.97C70.3786 11.83 70.6646 11.76 70.9846 11.76C71.2966 11.76 71.5746 11.828 71.8186 11.964C72.0626 12.1 72.2546 12.292 72.3946 12.54C72.5346 12.788 72.6046 13.08 72.6046 13.416C72.6046 13.448 72.6026 13.484 72.5986 13.524C72.5986 13.564 72.5966 13.602 72.5926 13.638H69.9226V13.14H72.1966L71.9026 13.296C71.9066 13.112 71.8686 12.95 71.7886 12.81C71.7086 12.67 71.5986 12.56 71.4586 12.48C71.3226 12.4 71.1646 12.36 70.9846 12.36C70.8006 12.36 70.6386 12.4 70.4986 12.48C70.3626 12.56 70.2546 12.672 70.1746 12.816C70.0986 12.956 70.0606 13.122 70.0606 13.314V13.434C70.0606 13.626 70.1046 13.796 70.1926 13.944C70.2806 14.092 70.4046 14.206 70.5646 14.286C70.7246 14.366 70.9086 14.406 71.1166 14.406C71.2966 14.406 71.4586 14.378 71.6026 14.322C71.7466 14.266 71.8746 14.178 71.9866 14.058L72.3886 14.52C72.2446 14.688 72.0626 14.818 71.8426 14.91C71.6266 14.998 71.3786 15.042 71.0986 15.042ZM75.101 15.042C74.841 15.042 74.603 14.982 74.387 14.862C74.175 14.742 74.005 14.562 73.877 14.322C73.753 14.078 73.691 13.77 73.691 13.398C73.691 13.022 73.751 12.714 73.871 12.474C73.995 12.234 74.163 12.056 74.375 11.94C74.587 11.82 74.829 11.76 75.101 11.76C75.417 11.76 75.695 11.828 75.935 11.964C76.179 12.1 76.371 12.29 76.511 12.534C76.655 12.778 76.727 13.066 76.727 13.398C76.727 13.73 76.655 14.02 76.511 14.268C76.371 14.512 76.179 14.702 75.935 14.838C75.695 14.974 75.417 15.042 75.101 15.042ZM73.325 16.164V11.796H74.039V12.552L74.015 13.404L74.075 14.256V16.164H73.325ZM75.017 14.4C75.197 14.4 75.357 14.36 75.497 14.28C75.641 14.2 75.755 14.084 75.839 13.932C75.923 13.78 75.965 13.602 75.965 13.398C75.965 13.19 75.923 13.012 75.839 12.864C75.755 12.712 75.641 12.596 75.497 12.516C75.357 12.436 75.197 12.396 75.017 12.396C74.837 12.396 74.675 12.436 74.531 12.516C74.387 12.596 74.273 12.712 74.189 12.864C74.105 13.012 74.063 13.19 74.063 13.398C74.063 13.602 74.105 13.78 74.189 13.932C74.273 14.084 74.387 14.2 74.531 14.28C74.675 14.36 74.837 14.4 75.017 14.4ZM78.8783 15.042C78.5503 15.042 78.2583 14.972 78.0023 14.832C77.7463 14.688 77.5443 14.492 77.3963 14.244C77.2483 13.996 77.1743 13.714 77.1743 13.398C77.1743 13.078 77.2483 12.796 77.3963 12.552C77.5443 12.304 77.7463 12.11 78.0023 11.97C78.2583 11.83 78.5503 11.76 78.8783 11.76C79.2103 11.76 79.5043 11.83 79.7603 11.97C80.0203 12.11 80.2223 12.302 80.3663 12.546C80.5143 12.79 80.5883 13.074 80.5883 13.398C80.5883 13.714 80.5143 13.996 80.3663 14.244C80.2223 14.492 80.0203 14.688 79.7603 14.832C79.5043 14.972 79.2103 15.042 78.8783 15.042ZM78.8783 14.4C79.0623 14.4 79.2263 14.36 79.3703 14.28C79.5143 14.2 79.6263 14.084 79.7063 13.932C79.7903 13.78 79.8323 13.602 79.8323 13.398C79.8323 13.19 79.7903 13.012 79.7063 12.864C79.6263 12.712 79.5143 12.596 79.3703 12.516C79.2263 12.436 79.0643 12.396 78.8843 12.396C78.7003 12.396 78.5363 12.436 78.3923 12.516C78.2523 12.596 78.1403 12.712 78.0563 12.864C77.9723 13.012 77.9303 13.19 77.9303 13.398C77.9303 13.602 77.9723 13.78 78.0563 13.932C78.1403 14.084 78.2523 14.2 78.3923 14.28C78.5363 14.36 78.6983 14.4 78.8783 14.4ZM81.3055 15V11.796H82.0195V12.678L81.9355 12.42C82.0315 12.204 82.1815 12.04 82.3855 11.928C82.5935 11.816 82.8515 11.76 83.1595 11.76V12.474C83.1275 12.466 83.0975 12.462 83.0695 12.462C83.0415 12.458 83.0135 12.456 82.9855 12.456C82.7015 12.456 82.4755 12.54 82.3075 12.708C82.1395 12.872 82.0555 13.118 82.0555 13.446V15H81.3055ZM85.1189 15.042C84.7669 15.042 84.4949 14.952 84.3029 14.772C84.1109 14.588 84.0149 14.318 84.0149 13.962V11.088H84.7649V13.944C84.7649 14.096 84.8029 14.214 84.8789 14.298C84.9589 14.382 85.0689 14.424 85.2089 14.424C85.3769 14.424 85.5169 14.38 85.6289 14.292L85.8389 14.826C85.7509 14.898 85.6429 14.952 85.5149 14.988C85.3869 15.024 85.2549 15.042 85.1189 15.042ZM83.4869 12.42V11.82H85.6229V12.42H83.4869Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2333_23956)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6791 30.305C27.6748 30.3688 27.673 30.4312 27.6733 30.4922C27.6829 32.1734 29.8948 32.7123 31.3624 31.892C31.8794 31.603 32.318 31.288 32.5947 31.1074C33.2588 30.674 35.7722 28.6258 36.111 27.9899C36.4497 27.3539 36.052 26.5417 35.3111 26.645C34.5701 26.7482 27.7872 28.6787 27.6791 30.305Z",
    fill: "url(#paint0_linear_2333_23956)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6791 30.305C27.6748 30.3688 27.673 30.4312 27.6733 30.4922C27.6829 32.1734 29.8948 32.7123 31.3624 31.892C31.8794 31.603 32.318 31.288 32.5947 31.1074C33.2588 30.674 35.7722 28.6258 36.111 27.9899C36.4497 27.3539 36.052 26.5417 35.3111 26.645C34.5701 26.7482 27.7872 28.6787 27.6791 30.305Z",
    fill: "url(#paint1_linear_2333_23956)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6222 30.0614C27.6179 30.1252 27.6161 30.1876 27.6164 30.2486C27.626 31.9297 29.838 32.4687 31.3055 31.6484C31.8226 31.3594 32.2611 31.0443 32.5378 30.8638C33.2019 30.4304 35.7153 28.3821 36.0541 27.7462C36.3928 27.1103 35.9951 26.2981 35.2542 26.4013C34.5132 26.5046 27.7303 28.435 27.6222 30.0614Z",
    fill: "url(#paint2_linear_2333_23956)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2333_23956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 10,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6234 30.0609C27.6192 30.1247 27.6173 30.1871 27.6176 30.2481C27.6273 31.9292 29.8392 32.4682 31.3067 31.6479C31.8238 31.3589 32.2624 31.0438 32.5391 30.8633C33.2031 30.4299 35.7165 28.3816 36.0553 27.7457C36.394 27.1098 35.9963 26.2976 35.2554 26.4008C34.5145 26.5041 27.7316 28.4345 27.6234 30.0609Z",
    fill: "url(#paint3_linear_2333_23956)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2333_23956)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.22009,
    ry: 4.14043,
    transform: "matrix(-0.595344 -0.803264 0.802944 -0.596334 33.2874 29.6222)",
    fill: "#6489DE"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08661 27.1522C2.14808 27.1335 2.2087 27.1174 2.26845 27.1039C3.90614 26.7324 4.93116 28.7641 4.46796 30.3782C4.30392 30.9499 4.09615 31.4508 3.98296 31.7624C3.71205 32.5082 2.28979 35.4234 1.74798 35.898C1.20617 36.3726 0.325721 36.1692 0.257994 35.4234C0.190268 34.6776 0.528901 27.6268 2.08661 27.1522Z",
    fill: "url(#paint4_linear_2333_23956)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08661 27.1522C2.14808 27.1335 2.2087 27.1174 2.26845 27.1039C3.90614 26.7324 4.93116 28.7641 4.46796 30.3782C4.30392 30.9499 4.09615 31.4508 3.98296 31.7624C3.71205 32.5082 2.28979 35.4234 1.74798 35.898C1.20617 36.3726 0.325721 36.1692 0.257994 35.4234C0.190268 34.6776 0.528901 27.6268 2.08661 27.1522Z",
    fill: "url(#paint5_linear_2333_23956)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83661 27.1525C1.89808 27.1337 1.9587 27.1177 2.01845 27.1041C3.65614 26.7327 4.68116 28.7643 4.21796 30.3785C4.05392 30.9501 3.84615 31.4511 3.73296 31.7626C3.46205 32.5084 2.03979 35.4237 1.49798 35.8982C0.956167 36.3728 0.075721 36.1694 0.00799444 35.4237C-0.0597322 34.6779 0.278901 27.627 1.83661 27.1525Z",
    fill: "url(#paint6_linear_2333_23956)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2333_23956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 27,
    width: 5,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83661 27.1525C1.89808 27.1337 1.9587 27.1177 2.01845 27.1041C3.65614 26.7327 4.68116 28.7643 4.21796 30.3785C4.05392 30.9501 3.84615 31.4511 3.73296 31.7626C3.46205 32.5084 2.03979 35.4237 1.49798 35.8982C0.956167 36.3728 0.075721 36.1694 0.00799444 35.4237C-0.0597322 34.6779 0.278901 27.627 1.83661 27.1525Z",
    fill: "url(#paint7_linear_2333_23956)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2333_23956)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.21928,
    ry: 4.1432,
    transform: "matrix(-0.917232 -0.398352 -0.397662 0.917532 2.69449 32.7741)",
    fill: "#6489DE"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.8511,
    y: 11.8984,
    width: 0.813557,
    height: 6.91524,
    rx: 0.406779,
    fill: "url(#paint8_linear_2333_23956)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2333_23956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 17,
    width: 4,
    height: 5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6114 17.0513H27.7666V21.3902H30.2174C30.2388 21.1906 30.2768 20.996 30.3403 20.8476C30.5435 20.3731 31.0853 18.5428 30.6114 17.0513Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2333_23956)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.7356,
    y: 16.7798,
    width: 7.17902,
    height: 4.61016,
    fill: "url(#paint9_linear_2333_23956)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6641,
    y: 17.0508,
    width: 1.76089,
    height: 4.33897,
    rx: 0.880446,
    fill: "url(#paint10_linear_2333_23956)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1912 26.4067C26.7206 26.4067 29.1223 24.8005 29.1223 22.2712C29.1223 15.494 23.6339 10 16.8637 10C10.0936 10 4.60522 15.494 4.60522 22.2712C4.60522 24.8005 7.00693 26.4067 9.53624 26.4067H24.1912Z",
    fill: "url(#paint11_linear_2333_23956)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5393 26.9485C25.9919 26.9485 29.1223 29.3064 29.1223 32.7591C29.1223 42.2807 23.6339 49.9995 16.8637 49.9995C10.0936 49.9995 4.60522 42.2807 4.60522 32.7591C4.60522 29.3064 7.7356 26.9485 11.1882 26.9485H22.5393Z",
    fill: "url(#paint12_linear_2333_23956)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2333_23956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 26,
    width: 26,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5384 26.9492C25.9908 26.9492 29.121 29.3071 29.121 32.7595C29.121 42.2812 23.6327 50 16.8625 50C10.0923 50 4.604 42.2812 4.604 32.7595C4.604 29.3071 7.73422 26.9492 11.1867 26.9492H22.5384Z",
    fill: "url(#paint13_linear_2333_23956)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2333_23956)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5038 25.3226C33.5038 24.3334 32.965 23.6373 32.5429 23.2476C32.1178 22.8553 31.6079 22.5751 31.1436 22.3678C30.2011 21.947 28.9675 21.6186 27.6045 21.3612C24.8444 20.8399 21.1195 20.5308 17.0658 20.5308C13.0121 20.5308 9.28725 20.8399 6.52712 21.3612C5.16416 21.6186 3.93048 21.947 2.98802 22.3678C2.52375 22.5751 2.01386 22.8553 1.58876 23.2476C1.1666 23.6373 0.627838 24.3334 0.627838 25.3226C0.627838 26.3117 1.1666 27.0078 1.58876 27.3975C2.01386 27.7899 2.52375 28.07 2.98802 28.2773C3.93048 28.6982 5.16416 29.0265 6.52712 29.2839C9.28725 29.8052 13.0121 30.1143 17.0658 30.1143C21.1195 30.1143 24.8444 29.8052 27.6045 29.2839C28.9675 29.0265 30.2011 28.6982 31.1436 28.2773C31.6079 28.07 32.1178 27.7899 32.5429 27.3975C32.965 27.0078 33.5038 26.3117 33.5038 25.3226Z",
    stroke: "#6A84A4",
    strokeWidth: 4.15985
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter3_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4567 44.5764C9.46208 44.5764 3.79182 48.2492 3.79182 52.7798C3.79182 57.3104 9.46208 60.9832 16.4567 60.9832C23.4513 60.9832 29.1216 57.3104 29.1216 52.7798C29.1216 48.2492 23.4513 44.5764 16.4567 44.5764Z",
    fill: "#6489DE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter4_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8631 35.3562C11.2151 35.3562 6.6364 39.029 6.6364 43.5596C6.6364 48.0902 11.2151 51.7629 16.8631 51.7629C22.5112 51.7629 27.0898 48.0902 27.0898 43.5596C27.0898 39.029 22.5112 35.3562 16.8631 35.3562Z",
    fill: "#6489DE"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3387 15.8607C10.5116 14.8856 11.3228 14.1515 12.3113 14.0921C13.5505 14.0176 15.2381 13.933 16.5247 13.9324C17.8797 13.9317 19.6746 14.0235 20.9393 14.1005C21.8641 14.1568 22.6402 14.8071 22.8715 15.7043C23.2244 17.0731 22.1908 18.4069 20.7773 18.4069H12.4733C11.1247 18.4069 10.1034 17.1887 10.3387 15.8607Z",
    fill: "#362DA8"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8361 16.239C10.9983 15.3731 11.7543 14.7456 12.6353 14.7456H20.6309C21.4565 14.7456 22.1799 15.2982 22.397 16.0948C22.7144 17.2592 21.8378 18.4066 20.6309 18.4066H12.6353C11.4892 18.4066 10.625 17.3654 10.8361 16.239Z",
    fill: "#192162"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0872,
    cy: 16.5082,
    rx: 1.21908,
    ry: 1.22034,
    fill: "#574CEC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3692,
    cy: 16.5084,
    rx: 1.21908,
    ry: 1.22034,
    fill: "#574CEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2333_23956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 25,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.60498,
    y: 11.356,
    width: 24.3816,
    height: 15.0508,
    rx: 7.5254,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2333_23956)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0864,
    cy: 16.5086,
    rx: 1.48999,
    ry: 1.49152,
    fill: "#1300FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter7_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3696,
    cy: 16.5086,
    rx: 1.48999,
    ry: 1.49152,
    fill: "#1300FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5048 26.8138C33.5048 25.8246 32.966 25.1285 32.5438 24.7389C32.1187 24.3465 31.6089 24.0663 31.1446 23.859C30.2021 23.4382 28.9684 23.1098 27.6055 22.8524C24.8454 22.3311 21.1205 22.022 17.0668 22.022C13.0131 22.022 9.28822 22.3311 6.5281 22.8524C5.16514 23.1098 3.93145 23.4382 2.989 23.859C2.52472 24.0663 2.01484 24.3465 1.58973 24.7389C1.16758 25.1285 0.628814 25.8246 0.628814 26.8138C0.628814 27.8029 1.16758 28.4991 1.58973 28.8887C2.01484 29.2811 2.52472 29.5612 2.989 29.7685C3.93145 30.1894 5.16514 30.5177 6.5281 30.7751C9.28822 31.2965 13.0131 31.6056 17.0668 31.6056C21.1205 31.6056 24.8454 31.2965 27.6055 30.7751C28.9684 30.5177 30.2021 30.1894 31.1446 29.7685C31.6089 29.5612 32.1187 29.2811 32.5438 28.8887C32.966 28.4991 33.5048 27.8029 33.5048 26.8138Z",
    stroke: "#6A84A4",
    strokeWidth: 4.15985
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter9_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9842,
    cy: 26.4064,
    rx: 1.49152,
    ry: 9.34628,
    transform: "rotate(-90 16.9842 26.4064)",
    fill: "#6A84A4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter10_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0664,
    cy: 26.4065,
    rx: 0.677964,
    ry: 6.63721,
    transform: "rotate(-90 17.0664 26.4065)",
    fill: "#6A84A4"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9996,
    cy: 35.6945,
    rx: 3.18315,
    ry: 3.18643,
    fill: "url(#paint14_linear_2333_23956)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9483 35.6944C18.9483 36.7724 18.0754 37.6451 17.0002 37.6451C15.925 37.6451 15.0522 36.7724 15.0522 35.6944C15.0522 34.6163 15.925 33.7436 17.0002 33.7436C18.0754 33.7436 18.9483 34.6163 18.9483 35.6944Z",
    fill: "#8279FF",
    stroke: "url(#paint15_linear_2333_23956)",
    strokeWidth: 1.38662
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8119 35.6947C18.8119 36.6979 17.9997 37.5099 16.9993 37.5099C15.9989 37.5099 15.1867 36.6979 15.1867 35.6947C15.1867 34.6916 15.9989 33.8796 16.9993 33.8796C17.9997 33.8796 18.8119 34.6916 18.8119 35.6947Z",
    stroke: "url(#paint16_linear_2333_23956)",
    strokeWidth: 1.38662
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5386,
    y: 33.9128,
    width: 0.992566,
    height: 3.40229,
    rx: 0.496283,
    fill: "#9D96FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7341,
    y: 35.1172,
    width: 0.993589,
    height: 3.39879,
    rx: 0.496794,
    transform: "rotate(90 18.7341 35.1172)",
    fill: "#9D96FF"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0255 34.0881C16.779 34.0881 16.5792 34.2879 16.5792 34.5344V35.1697H15.946C15.6995 35.1697 15.4998 35.3695 15.4998 35.6159C15.4998 35.8624 15.6995 36.0621 15.946 36.0621H16.5792V36.6979C16.5792 36.9444 16.779 37.1442 17.0255 37.1442C17.2719 37.1442 17.4717 36.9444 17.4717 36.6979V36.0621H18.1064C18.3529 36.0621 18.5526 35.8624 18.5526 35.6159C18.5526 35.3695 18.3529 35.1697 18.1064 35.1697H17.4717V34.5344C17.4717 34.2879 17.2719 34.0881 17.0255 34.0881Z",
    fill: "#FCFCFA"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter13_f_2333_23956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0082 34.5208C16.8036 34.5208 16.6378 34.6866 16.6378 34.8911C16.6378 35.1266 16.447 35.3174 16.2116 35.3174H16.0691C15.8876 35.3174 15.7405 35.4645 15.7405 35.646C15.7405 35.8275 15.8876 35.9746 16.0691 35.9746H16.2115C16.4469 35.9746 16.6378 36.1655 16.6378 36.401C16.6378 36.6055 16.8036 36.7714 17.0082 36.7714C17.2128 36.7714 17.3786 36.6055 17.3786 36.401C17.3786 36.1655 17.5695 35.9746 17.8049 35.9746H17.9459C18.1274 35.9746 18.2745 35.8275 18.2745 35.646C18.2745 35.4645 18.1274 35.3174 17.9459 35.3174H17.8048C17.5694 35.3174 17.3786 35.1266 17.3786 34.8911C17.3786 34.6866 17.2128 34.5208 17.0082 34.5208Z",
    fill: "#FCFCFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2333_23956",
    x: 24.3373,
    y: 21.4186,
    width: 17.9003,
    height: 16.4071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77324,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2333_23956",
    x: -4.84359,
    y: 23.3947,
    width: 15.0761,
    height: 18.7587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77324,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2333_23956",
    x: -11.1585,
    y: 8.7446,
    width: 56.4485,
    height: 33.1561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.85316,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2333_23956",
    x: -28.1005,
    y: 12.6842,
    width: 89.1142,
    height: 80.1911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9461,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2333_23956",
    x: -25.2557,
    y: 3.464,
    width: 84.2378,
    height: 80.1911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9461,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_2333_23956",
    x: 10.3049,
    y: 13.9324,
    width: 12.6362,
    height: 5.86123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2333_23956",
    x: 9.8232,
    y: 12.2439,
    width: 8.52645,
    height: 8.52962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38662,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2333_23956",
    x: 15.1064,
    y: 12.2439,
    width: 8.52645,
    height: 8.52962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38662,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2333_23956",
    x: -11.1575,
    y: 10.2358,
    width: 56.4485,
    height: 33.1561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.85316,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2333_23956",
    x: -2.06838,
    y: 15.2085,
    width: 38.1053,
    height: 22.3958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.85316,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2333_23956",
    x: -4.82359,
    y: 10.4757,
    width: 43.78,
    height: 31.8615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6264,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2333_23956",
    x: 13.1068,
    y: 31.7997,
    width: 7.78495,
    height: 7.79008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.693309,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2333_23956",
    x: 14.653,
    y: 33.2414,
    width: 4.74644,
    height: 4.74961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.423365,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2333_23956",
    x: 12.5845,
    y: 31.3648,
    width: 8.84593,
    height: 8.56273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.578,
    result: "effect1_foregroundBlur_2333_23956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2333_23956",
    x1: 31.5023,
    y1: 34.9286,
    x2: 30.0426,
    y2: 29.0812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2333_23956",
    x1: 32.2527,
    y1: 31.9314,
    x2: 30.3334,
    y2: 23.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571374,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2333_23956",
    x1: 31.4455,
    y1: 34.685,
    x2: 29.9857,
    y2: 28.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2333_23956",
    x1: 31.4467,
    y1: 34.6845,
    x2: 29.9869,
    y2: 28.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2333_23956",
    x1: 7.45269,
    y1: 29.8301,
    x2: 1.43233,
    y2: 29.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2333_23956",
    x1: 4.70703,
    y1: 31.2419,
    x2: -3.46381,
    y2: 31.1793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571374,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2333_23956",
    x1: 7.20269,
    y1: 29.8304,
    x2: 1.18233,
    y2: 29.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2333_23956",
    x1: 7.20269,
    y1: 29.8304,
    x2: 1.18233,
    y2: 29.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2333_23956",
    x1: 28.8511,
    y1: 15.0849,
    x2: 30.2748,
    y2: 15.0849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589912,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2333_23956",
    x1: 30.1054,
    y1: 21.2543,
    x2: 29.9368,
    y2: 14.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571374,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2333_23956",
    x1: 29.6641,
    y1: 19.0501,
    x2: 32.8922,
    y2: 19.0296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571374,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2333_23956",
    x1: -10.4978,
    y1: 15.0169,
    x2: 22.5529,
    y2: 13.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2333_23956",
    x1: -10.4978,
    y1: 42.9509,
    x2: 22.589,
    y2: 44.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2333_23956",
    x1: -10.499,
    y1: 42.9514,
    x2: 22.5878,
    y2: 44.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176794,
    stopColor: "#8FA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2333_23956",
    x1: 13.8164,
    y1: 35.4446,
    x2: 24.9574,
    y2: 35.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589912,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2333_23956",
    x1: 19.6416,
    y1: 36.0333,
    x2: 14.3589,
    y2: 35.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6157EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2333_23956",
    x1: 19.5052,
    y1: 36.0163,
    x2: 14.4934,
    y2: 35.7596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6157EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2333_23956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.032,
    height: 40,
    fill: "white",
    transform: "translate(0 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGethelp);
export default __webpack_public_path__ + "static/media/gethelp.34f98626a645b6781213c2f2a56529f8.svg";
export { ForwardRef as ReactComponent };